// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E2mm","colBig":"styles_colBig__25wmf","colSmall":"styles_colSmall__3hD0X"};